import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError, catchError } from 'rxjs';

export const errorInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    const router = inject(Router);

    return next(req).pipe(
        catchError((error) => {
            if (error instanceof HttpErrorResponse && error.status === 500) {
                const errorBody = error.error;
                if (errorBody && errorBody.status === 'INTERNAL_SERVER_ERROR') {
                    const message = errorBody.message;
                    if (message && typeof message === 'string' && message.startsWith('Connection refused')) {
                        router.navigate(['/error-500']);
                    }
                }
            }
            return throwError(() => error);
        })
    );
};
